import './Header.css';

import Masthead, { MastheadMenuButton, MastheadTitle } from '@amzn/meridian/masthead';
import { Navbar, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { BADGE_PATH } from '../../global/constants';
import Heading from '@amzn/meridian/heading';
import UserProfile from '../../global/user-profile';
import logo from '../../static/customer_service.jpg';
import TenantSelector from '../tenant-selector/TenantSelector';

const Header = ({ toggleIsSidebarOpen, onTenantIdChange, availableTenantIds }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [jobTitle, setJobTitle] = useState(null);

  useEffect(() => {
    UserProfile.getUserInformation().then(info => {
      const badgeUrl = BADGE_PATH + info.username;

      setImageUrl(badgeUrl);
      setFullName(info.fullName);
      setJobTitle(info.jobTitle);
    });
  }, []);

  return (
    <Masthead>
      <MastheadMenuButton onClick={toggleIsSidebarOpen} />
      <MastheadTitle href="#">
        <div className="navbar-rts-logo">
          <img src={logo} alt="Customer Service Logo  " />
          <Heading level={3}>Luminous App</Heading>
        </div>
      </MastheadTitle>
      <TenantSelector availableTenantIds={availableTenantIds} onChange={onTenantIdChange} />
      <Navbar className="m-0 navbar-user-info navbar-height navbar-colors">
        <Navbar.Collapse className="justify-content-end m-0 p-0 pr-3">
          <Navbar.Brand className="pt-0 pb-0 pr-1">
            {imageUrl && <img height="40" alt="Profile" src={imageUrl} />}
          </Navbar.Brand>
          <Navbar.Text className="pt-0 pb-0 pl-1 pr-2 text-color-white">
            <Row className="">{fullName}</Row>
            <Row className="">{jobTitle}</Row>
          </Navbar.Text>
        </Navbar.Collapse>
      </Navbar>
    </Masthead>
  );
};

export default Header;
